<template>
  <div class="ui-menu">
    <List
      :name="name"
      :fields="fields"
      :max-levels="2"
      item-label="{linkText}"
      add-item-label="Adicionar item ao menu"
    />
  </div>
</template>

<script>
import List from '@/ui-types/List.vue';
import uniqueId from '@/helpers/uniqueId';
import commonProperties from './common-properties';

export default {
  name: 'Menu',
  components: {
    List,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    fields: {
      type: Array,
      default: () => [
        {
          name: 'linkText',
          type: 'ShortText',
          label: 'Título',
        },
        {
          name: 'linkUrl',
          type: 'Url',
        },
      ],
    },
  },
  created() {
    // Legacy menus didn't have keys id and menuLinks
    const isLegacyMenu = this.model[0] && !this.model[0].id;

    if (isLegacyMenu) {
      this.model = this.model.map((item) => ({
        id: uniqueId(),
        menuLinks: [],
        ...item,
      }));
    }

    // Deal with default unedited id for menu link
    const unwatch = this.$watch('model', {
      handler() {
        const uneditedDefault = this.model.find(
          ({ id }) => id === 'DefaultUneditedId',
        );
        if (uneditedDefault) {
          uneditedDefault.id = uniqueId();
        }

        unwatch();
      },
      deep: true,
    });
  },
};
</script>
